import { IViews } from 'app/modules/shared-area/ducks/panel/models/IViews';

export class ClientInfo {
  namedViews: IViews;
}
